import PropTypes from 'prop-types';
import React from 'react';

import { Container, Flex } from '../grid';
import { matrixBlockQuery } from '../../content/query-snippets';
import { RichText, H4 } from '../typography/new';

const ContentBlock = ({ body, blockTitle }) => (
  <Container my={{ xs: '64px', lg: '120px' }}>
    <Flex width="100%" justifyContent="center">
      <Flex flexDirection="column" width={{ xs: '100%', md: 8 / 12 }} textAlign="center">
        <H4 my="0">{blockTitle}</H4>
        <RichText mt={blockTitle && '20px'}>{body}</RichText>
      </Flex>
    </Flex>
  </Container>
);

ContentBlock.query = `
  ... on contentMatrix_contentBlock_BlockType {
    ${matrixBlockQuery}
    blockTitle
    body
  }
`;

ContentBlock.propTypes = {
  body: PropTypes.string.isRequired,
  blockTitle: PropTypes.string.isRequired,
};

export { ContentBlock };
